export default "__VITE_ASSET__CUrhcS7D__"